import { localize } from "@gtmhub/localization";
import { IGridFilter, IGridFilterDefinition, IGridSortingRule } from "@gtmhub/shared/components/grid-filtering-bar";
import { IGHGridColumn } from "@gtmhub/shared/components/grid/grid.component";

export const tagsGridColumns: IGHGridColumn[] = [
  {
    fieldName: "title",
    label: "Tag name",
    width: 180,
    type: "alphabetic",
    isCustom: false,
    visible: true,
    widthModifiedByUser: true,
  },
  {
    fieldName: "isActive",
    label: "Status",
    width: 120,
    type: "boolean",
    isCustom: false,
    visible: true,
  },
  {
    fieldName: "createdBy",
    label: "Created by",
    width: 220,
    type: "alphabetic",
    isCustom: false,
    visible: true,
    widthModifiedByUser: true,
  },
  {
    fieldName: "dateCreated",
    label: "Date created",
    width: 140,
    type: "date",
    isCustom: false,
    visible: true,
    widthModifiedByUser: true,
  },
  {
    fieldName: "goalsTaggedCount",
    label: "Objectives",
    width: 140,
    type: "numeric",
    isCustom: false,
    visible: true,
    widthModifiedByUser: true,
  },
  {
    fieldName: "dashboardsTaggedCount",
    label: "Insightboards",
    width: 140,
    type: "numeric",
    isCustom: false,
    visible: true,
    widthModifiedByUser: true,
  },
  {
    fieldName: "actions",
    width: 50,
    type: "dropdown",
    isCustom: false,
    visible: true,
  },
];

export const tagsGridFilterDefinitions: IGridFilterDefinition[] = [
  {
    fieldName: "title",
    displayName: localize("title"),
    trackingName: "Title",
    dataType: "text",
    placeholder: localize("search_for_tags"),
    defaultOperator: "contains",
    supportedOperators: ["equals", "notEqual", "contains", "doesNotContain"],
    defaultValue: "",
  },
  {
    fieldName: "isActive",
    displayName: localize("status"),
    trackingName: "Status",
    dataType: "enum",
    arrayType: "static",
    placeholder: localize("status_is"),
    entries: [
      { displayName: localize("active"), value: true },
      { displayName: localize("archived"), value: false },
    ],
    defaultOperator: "equals",
    supportedOperators: ["equals", "notEqual"],
  },
  {
    fieldName: "createdBy",
    displayName: localize("created_by"),
    trackingName: "Created by",
    dataType: "array",
    arrayType: "assignee",
    defaultOperator: "isOneOf",
    supportedOperators: ["isOneOf"],
  },
  {
    fieldName: "dateCreated",
    displayName: localize("date_created_cap"),
    trackingName: "Date created",
    dataType: "date",
    defaultOperator: "isBefore",
    supportedOperators: ["isBefore", "isAfter", "isBetween", "isNotBetween"],
  },
  {
    fieldName: "goalsTaggedCount",
    displayName: localize("objectives"),
    trackingName: "Used in goals",
    dataType: "numeric",
    defaultOperator: "greater",
    supportedOperators: ["equals", "greater", "less"],
  },
  {
    fieldName: "dashboardsTaggedCount",
    displayName: localize("insightboards"),
    trackingName: "Used in dashboards",
    dataType: "numeric",
    defaultOperator: "greater",
    supportedOperators: ["equals", "greater", "less"],
  },
];

export const defaultFilters: IGridFilter[] = [
  { fieldName: "title", dataType: "text", operator: "contains" },
  { fieldName: "createdBy", dataType: "array", operator: "isOneOf" },
];

export const defaultSortingRules: IGridSortingRule[] = [{ fieldName: "dateCreated", reversed: true }];
